import * as React from "react";
import { process, filterBy } from "@progress/kendo-data-query";
import {
    Grid,
    GridColumn as Column,
    GridColumnMenuFilter,
    getSelectedState,
    GridColumnMenuWrapper,
} from "@progress/kendo-react-grid";
import { getter } from "@progress/kendo-react-common";
import './index.scss'
import { useState, useEffect } from "react";
import { MyCommandCell } from "./mycommandcell";
import { LocalizationProvider, loadMessages } from '@progress/kendo-react-intl';
import { Tooltip } from "@progress/kendo-react-tooltip";
import { CellRender, RowRender } from "./renderers";
import { RESOURCE } from "../../../const/resource";
import { useTranslation } from "react-i18next";
import { DragAndDrop } from "@progress/kendo-react-common";
import { DraggableRow } from "./draggable-row";
import { DragHandleCell } from "./drag-handle-cell";
import {
    DateInputProps,
    DateInputPropsContext,
} from '@progress/kendo-react-dateinputs';
import {
    setGroupIds,
    setExpandedState,
} from "@progress/kendo-react-data-tools";
import { REGION } from "../../../const/linksection";
import { useSelector } from "react-redux";
import { selectors as headerSelector } from "../../../state/features/header";
import DateTimeFilter from "./datetimefilter";
import MonthYearFilter from "./monthYear";
import helperfunctions from "../../../utils/helperfunctions";

const processWithGroups = (data: any, dataState: any) => {
    const newDataState = process(data, dataState);
    setGroupIds({
        data: newDataState.data,
        group: dataState.group,
    });
    return newDataState;
};



const filterOperators = {
    text: [{ text: "grid.filterContainsOperator", operator: "contains" }],
    numeric: [{ text: "grid.filterEqOperator", operator: "eq" }, { text: 'grid.filterGtOperator', operator: 'gt' }, { text: 'grid.filterLtOperator', operator: 'lt' }],
    date: [{ text: "grid.filterEqOperator", operator: "eq" }, { text: 'grid.filterAfterOperator', operator: 'gt' }, { text: 'grid.filterBeforeOperator', operator: 'lt' },],
    dateTime: [
        { operator: 'eq', text: 'grid.filterEqOperator' },
        { operator: 'neq', text: 'grid.filterNotEqOperator' },
        { operator: 'gt', text: 'grid.filterAfterOperator' },
        { operator: 'lt', text: 'grid.filterBeforeOperator' }
    ],
    boolean: [{ text: "grid.filterEqOperator", operator: "eq" }],
    monthYear: [{ text: "grid.filterEqOperator", operator: "eq" }, { text: 'grid.filterAfterOperator', operator: 'gt' }, { text: 'grid.filterBeforeOperator', operator: 'lt' },],
};
const ColumnMenuconst = (ColumnMenuitem: any) => {
    if (ColumnMenuitem?.column?.filter === 'dateTime') {
        return (
            <div>
                <GridColumnMenuFilter
                    {...ColumnMenuitem}
                    filterUI={DateTimeFilter}
                    expanded={true}
                    hideSecondFilter
                />
            </div>
        );
    }
    else if (ColumnMenuitem?.column?.filter === 'monthYear') {
        return (
            <div>
                <GridColumnMenuFilter
                    {...ColumnMenuitem}
                    filterUI={MonthYearFilter}
                    expanded={true}
                    hideSecondFilter
                />
            </div>
        );
    }
    else {
        return (
            <div>
                <GridColumnMenuFilter {...ColumnMenuitem} expanded={true} hideSecondFilter />
            </div>
        );
    }
}

type ContextProps = {
    reorder: any;
    dragStart: any;
};

export const ReorderContext = React.createContext<ContextProps>({
    reorder: () => { },
    dragStart: () => { },
})



const DataTable = (props: any) => {

    const { t } = useTranslation();

    const [collpaseExpandMode, setCollapseExpandMode] = useState(false);
    const [isSelectChangeEventCallRequired, setIsSelectChangeEventCallRequired] = useState(false);
    const { headercurrentuser }: any = useSelector((state) => ({
        headercurrentuser: headerSelector.currentuser(state),
    }));

    const getDTFormat = (defaultFormat: any) => {
        const defaultFormatConst = defaultFormat ? defaultFormat?.toLowerCase() : "";
        if (defaultFormatConst == "dd-mmm-yyyy")
            return "dd-MMM-yyyy";
        else if (defaultFormatConst == "mm/dd/yyyy")
            return "MM/dd/yyyy";
        else
            return defaultFormat;
    }


    const fetchFormat = () => {
        const defaultFormatConst = headercurrentuser?.defaultDateFormat ? headercurrentuser?.defaultDateFormat?.toLowerCase() : "";
        if (defaultFormatConst == "dd-mmm-yyyy") {
            return (defaultFormatConst) ? getDTFormat(defaultFormatConst) : 'dd-MMM-yyyy';
        } else {
            return (headercurrentuser?.userpreference?.culture != '' && headercurrentuser?.userpreference?.culture != "en_us" && headercurrentuser?.userpreference?.culture != "en_ca") ? 'dd/MM/yyyy' : 'MM/dd/yyyy'
        }
    }

    const dateInputProps: any = React.useCallback(
        (dateInputProps: DateInputProps) => ({
            ...dateInputProps,
            format: props?.isMonthYear ? 'MMM yyyy' : (props?.isTime ? fetchFormat() + ' HH:mm:ss' : fetchFormat()),
            formatPlaceholder: 'formatPattern',
        }),
        [props?.isMonthYear]
    );

    loadMessages(
        {
            grid: {
                groupPanelEmpty: t(RESOURCE.MyK_DataTable_groupPanelEmpty),
                pagerItemsPerPage: t(RESOURCE.MyK_DataTable_pagerItemsPerPage),
                pagerFirstPage: t(RESOURCE.MyK_DataTable_pagerFirstPage),
                pagerPreviousPage: t(RESOURCE.MyK_DataTable_pagerPreviousPage),
                pagerNextPage: t(RESOURCE.MyK_DataTable_pagerNextPage),
                pagerLastPage: t(RESOURCE.MyK_DataTable_pagerLastPage),
                pagerPage: t(RESOURCE.MyK_DataTable_pagerPage),
                pagerOf: t(RESOURCE.MyK_DataTable_pagerOf),
                pagerTotalPages: t(RESOURCE.MyK_DataTable_pagerTotalPages),
                pagerInfo: t(RESOURCE.MyK_DataTable_pagerInfo),
                pagerItemPerPage: t(RESOURCE.MyK_DataTable_pagerItemPerPage),
                filterClearButton: t(RESOURCE.MyK_DataTable_filterClearButton),
                filterEqOperator: t(RESOURCE.MyK_DataTable_filterEqOperator),
                filterNotEqOperator: t(RESOURCE.MyK_DataTable_filterNotEqOperator),
                filterIsNullOperator: t(RESOURCE.MyK_DataTable_filterIsNullOperator),
                filterIsNotNullOperator: t(RESOURCE.MyK_DataTable_filterIsNotNullOperator),
                filterIsEmptyOperator: t(RESOURCE.MyK_DataTable_filterIsEmptyOperator),
                filterIsNotEmptyOperator: t(RESOURCE.MyK_DataTable_filterIsNotEmptyOperator),
                filterStartsWithOperator: t(RESOURCE.MyK_DataTable_filterStartsWithOperator),
                filterContainsOperator: t(RESOURCE.MyK_DataTable_filterContainsOperator),
                filterNotContainsOperator: t(RESOURCE.MyK_DataTable_filterNotContainsOperator),
                filterEndsWithOperator: t(RESOURCE.MyK_DataTable_filterEndsWithOperator),
                filterGteOperator: t(RESOURCE.MyK_DataTable_filterGteOperator),
                filterGtOperator: t(RESOURCE.MyK_DataTable_filterGtOperator),
                filterLteOperator: t(RESOURCE.MyK_DataTable_filterLteOperator),
                filterLtOperator: t(RESOURCE.MyK_DataTable_filterLtOperator),
                filterIsTrue: t(RESOURCE.MyK_DataTable_filterIsTrue),
                filterIsFalse: t(RESOURCE.MyK_DataTable_filterIsFalse),
                filterBooleanAll: t(RESOURCE.MyK_DataTable_filterBooleanAll),
                filterAfterOrEqualOperator: t(RESOURCE.MyK_DataTable_filterAfterOrEqualOperator),
                filterAfterOperator: t(RESOURCE.MyK_DataTable_filterAfterOperator),
                filterBeforeOperator: t(RESOURCE.MyK_DataTable_filterBeforeOperator),
                filterBeforeOrEqualOperator: t(RESOURCE.MyK_DataTable_filterBeforeOrEqualOperator),
                filterSubmitButton: t(RESOURCE.MyK_DataTable_filterSubmitButton),
                filterAndLogic: t(RESOURCE.MyK_DataTable_filterAndLogic),
                filterOrLogic: t(RESOURCE.MyK_DataTable_filterOrLogic),
                filterTitle: t(RESOURCE.MyK_DataTable_filterTitle),
                filterChooseOperator: t(RESOURCE.MyK_DataTable_filterChooseOperator),
                filterSelectedItems: t(RESOURCE.MyK_DataTable_filterSelectedItems),
                filterAriaLabel: t(RESOURCE.MyK_DataTable_filterAriaLabel),
                sortAscending: t(RESOURCE.MyK_DataTable_sortAscending),
                sortDescending: t(RESOURCE.MyK_DataTable_sortDescending),
                sortAriaLabel: t(RESOURCE.MyK_DataTable_sortAriaLabel),
                searchPlaceholder: t(RESOURCE.MyK_DataTable_searchPlaceholder),
                noRecords: t(RESOURCE.MyK_DataTable_noRecords),
                filterCheckAll: t(RESOURCE.MyK_DataTable_filterCheckAll),
                groupColumn: t(RESOURCE.MyK_DataTable_groupColumn),
                groupExpand: t(RESOURCE.MyK_DataTable_groupExpand),
                groupCollapse: t(RESOURCE.MyK_DataTable_groupCollapse),
                groupPanelAriaLabel: t(RESOURCE.MyK_DataTable_groupPanelAriaLabel),
                ungroupColumn: t(RESOURCE.MyK_DataTable_ungroupColumn),
                detailExpand: t(RESOURCE.MyK_DataTable_detailExpand),
                detailCollapse: t(RESOURCE.MyK_DataTable_detailCollapse),
            },
        },
        'en'
    );

    const [selectedState, setSelectedState] = useState<{
        [id: string]: boolean | number[];
    }>({});
    const {
        data,
        defaultPageSize = 10,
        selection = false,
        isSelect = false,
        DetailRow = false,
        inlineEdit = false,
        inlineRowEdit = false,
        sortable = true,
        pagination = true,
        getSelectedValue,
        edit,
        update,
        cancel,
        total,
        isExpandWithItemChange = false,
        rowReOrder = false,
    } = props


    React.useEffect(() => {
        if (selection) {
            const getClass = document.querySelector(".SelectAllcls");
            const paraClss = document.createElement("span");
            if (!isSelect) {
                paraClss.setAttribute('title', t(RESOURCE.MyK_Myhealth_TreeView_SelectAll));
                paraClss.innerText = t(RESOURCE.MyK_Myhealth_TreeView_SelectAll);
                paraClss.setAttribute('class', 'CustomSelectalltxt');
            } else {
                paraClss.setAttribute('title', t(RESOURCE.MyK_Select));
                paraClss.innerText = t(RESOURCE.MyK_Select);
                paraClss.setAttribute('class', 'CustomSelecttxt');
            }
            getClass?.appendChild(paraClss);
        } else {
            document.querySelector(".CustomSelectalltxt")?.remove();
        }

    }, [selection, isSelect]);

    React.useEffect(() => {
        if (props?.selectedCredit)
            setSelectedState(props?.selectedCredit)

    }, [props?.selectedCredit])

    const SELECTED_FIELD: string = props.selectedField;
    const DATA_ITEM_KEY: string = props.dataItemKey;
    const idGetter = getter(DATA_ITEM_KEY);
    const EDIT_FIELD: string = "inEdit";

    const createDataState = (dataState: any) => {
        return {
            result: process(data, dataState),
            dataState: dataState,
        };
    };
    const createState = (skip: number, take: number) => {
        let pagerSettings: any = {
            buttonCount: 5,
            info: true,
            type: "numeric",
            pageSizes: props?.defaultPageSize == 100 ? [10, 25, 50, 100] : [3, 5, 10, 20],
            previousNext: true,
        };

        return {
            items: data,
            total: total,
            skip: skip,
            pageSize: take,
            pageable: pagerSettings,
        };
    };
    let initialState = createDataState({
        take: props?.defaultPageSize,
        skip: 0
    });

    const [result, setResult] = useState<any>(initialState.result);
    const [dataState, setDataState] = useState<any>(
        initialState.dataState
    );
    const [state] = useState(createState(0, 10));
    const [collapsedState, setCollapsedState] = React.useState<any>([]);
    const [activeItem, setActiveItem] = useState(null);

    useEffect(() => {
        if (props.firstPage) {
            setDataState({ take: 10, skip: 0 })
        }
    }, [props.data]);

    useEffect(() => {
        if (props.groupable) {
            if (data?.length) {
                setResult(processWithGroups(data, dataState))
            }
        }
        else {
            if (!collpaseExpandMode) {
                setResult(process(data, dataState));
            }
            else {
                setResult(processWithGroups(data, dataState));
            }
        }
    }, [data]);

    useEffect(() => {
        if (props.groupable) {
            const newData = setExpandedState({
                data: result?.data,
                collapsedIds: collapsedState,
            });
            setResult({ ...result, data: newData });
        }
    }, [collapsedState])

    const dataStateChange = (event: any) => {
        const dataFilterTemp = filterBy(data, event.dataState.filter);
        if (props?.exportRef) {
            if (!props?.exportRef?.current?.data) {
                props.exportRef.current = { data: [] };
            }
            props.exportRef.current.data = dataFilterTemp;
        }

        if (props.groupable) {
            if (
                event.dataState.group &&
                props?.dataColumn.length > event.dataState.group.length
            ) {
                props?.dataColumn.map((col: any) => {
                    col.show = true;
                    return col;
                });
                event.dataState.group.forEach((group: any) => {
                    for (let i = 0; i < props?.dataColumn.length; i++) {
                        if (group.title == props?.dataColumn[i].title) {

                            props.dataColumn[i].show = false;
                        }
                    }
                });
            }
            setResult(processWithGroups(data, event.dataState));
        }
        else {
            const isExpandAll = props.isExpandAll;
            const isAnyCollapsed = process(data, event.dataState)?.data?.some((item: any) => item.isSingle === false);
            const isAnyExpanded = process(data, event.dataState)?.data?.some((item: any) => item.isSingle === true);
            const newDataNested = process(data, event.dataState)?.data?.map((item: any) => {
                if ((isExpandAll && isExpandAll === undefined && isAnyCollapsed) || (!isExpandAll && isExpandAll === undefined && isAnyExpanded)) {
                    if (item.isSingle === true && isExpandAll === true) {
                        item.expanded = isExpandAll != undefined ? isExpandAll : undefined;
                        // item.isSingle = isExpandAll != undefined ? !isExpandAll : undefined;
                    }
                }
                else {
                    item.expanded = isExpandAll != undefined ? isExpandAll : undefined;
                    item.isSingle = isExpandAll != undefined ? isExpandAll : undefined;
                }
                return item;
            });
            setResult({ ...result, data: newDataNested, total: dataFilterTemp?.length ?? result?.total });
        }
        setDataState(event.dataState);
    };

    const updateExpandState = () => {
        let newDataNested = result?.data?.map((item: any) => {
            item.expanded = props.isExpandAll != undefined ? props.isExpandAll : undefined;
            item.isSingle = props.isExpandAll;
            return item;
        });
        setResult({ ...result, data: newDataNested });
    };

    useEffect(() => {
        updateExpandState();
    }, [props.isExpandAll]);


    const onExpand = React.useCallback(
        (event: any) => {
            if (props.groupable) {
                const item = event.dataItem;
                if (item.groupId) {
                    const collapsedIds = !event.value
                        ? [...collapsedState, item.groupId]
                        : collapsedState.filter((groupId: any) => groupId !== item.groupId);
                    setCollapsedState(collapsedIds);
                }
            }
            else if (DATA_ITEM_KEY != "" && DATA_ITEM_KEY != null) {

                let newDataNested = result?.data?.map((item: any) => {
                    if ((item[DATA_ITEM_KEY] === event.dataItem[DATA_ITEM_KEY])) {
                        item.expanded = !event.dataItem.expanded
                        item.isSingle = props.isExpandAll === undefined ? !event.dataItem.isSingle : props.isExpandAll
                    }
                    return item;
                });

                setResult({ ...result, data: newDataNested });
                setCollapseExpandMode(true);
            }
        },
        [collapsedState, result?.data]
    );
    const enterEdit = (dataItem: any, field: string | undefined) => {
        const newData = data.map((item: any) => ({
            ...item,
            [EDIT_FIELD]: item[DATA_ITEM_KEY] === dataItem[DATA_ITEM_KEY] ? field : undefined,
        }));

        let resultData = process(newData, dataState);
        setResult(resultData);
    };

    const exitEdit = () => {
        const newData = data.map((item: any) => ({ ...item, [EDIT_FIELD]: undefined }));
        let resultData = process(newData, dataState);
        setResult(resultData);
    };
    const customCellRender: any = (
        td: React.ReactElement<HTMLTableCellElement>,
        props: any
    ) => (
        <CellRender
            originalProps={props}
            td={td}
            enterEdit={enterEdit}
            editField={EDIT_FIELD}
        />
    );
    const customRowRender: any = (
        tr: React.ReactElement<HTMLTableRowElement>,
        props: any
    ) => (
        <RowRender
            originalProps={props}
            tr={tr}
            exitEdit={exitEdit}
            editField={EDIT_FIELD}
        />
    );

    React.useEffect(() => {
        if (props?.rememberSelected) {
            if (data?.length > 0 && props?.selectedEventData.dataItems?.length > 0) {
                setIsSelectChangeEventCallRequired(true);
                const resultObject: { [masterID: number]: boolean } = {};
                props?.selectedEventData?.dataItems?.forEach((item: any) => {
                    if (item.selected) {
                        resultObject[item.masterID] = true;
                    }
                });
                setSelectedState(resultObject);
            }
        }
    }, [data])

    React.useEffect(() => {
        if (isSelectChangeEventCallRequired) {
            onSelectionChange(props.selectedEventData);
        }
    }, [selectedState]);

    const onSelectionChange = React.useCallback(
        (event: any) => {
            setIsSelectChangeEventCallRequired(false);
            const newSelectedState = getSelectedState({
                event,
                selectedState: selectedState,
                dataItemKey: DATA_ITEM_KEY,
            });
            if (isSelect && newSelectedState.hasOwnProperty(Object.keys(selectedState)?.[0])) {
                delete newSelectedState[Object.keys(selectedState)?.[0]];
            }
            setSelectedState(newSelectedState);
            if (props.rememberSelected) {
                props.setSelectedStateEvent(event);
            }
            getSelectedItems(newSelectedState, event.dataItems);
        },
        [selectedState]
    );

    const onHeaderSelectionChange = React.useCallback(
        (event: any, data: any) => {
            const checkboxElement: any = event.syntheticEvent.target;
            const checked = checkboxElement.checked;
            const newSelectedState: any = {};
            result?.data?.forEach((item: any) => {
                newSelectedState[idGetter(item)] = checked;
            });
            setSelectedState(newSelectedState);
            getSelectedItems(newSelectedState, data);
        },
        [result]
    );

    const getSelectedItems = (selectedState: any, dataList: any) => {
        if (selectedState != null) {
            let selectedIds: string[] = [];
            let keys: any[] = Object.keys(selectedState);
            for (let key in keys) {
                if (selectedState[keys[key]]) {
                    selectedIds.push(keys[key])
                }
            }
            let selectedData = dataList.filter((item: any) =>
                selectedIds.indexOf(item[DATA_ITEM_KEY] ? item[DATA_ITEM_KEY].toString() : '')
                > -1);
            getSelectedValue(selectedData ?? []);

        }
    }

    const headerCellComponent = (props: any) => {
        return (
            <>
                <a className="k-link" onClick={props.onClick} onKeyDown={() => { }}>
                    <span className='k-column-title' title={props.title}>{props.title}</span>
                    {props.children}
                </a>
                <GridColumnMenuWrapper {...props.columnMenuWrapperProps} /></>
        )
    }

    const itemChange = (event: any) => {
        const field = event.field || "";
        const newData = data.map((item: any) =>
            item[DATA_ITEM_KEY] === event.dataItem[DATA_ITEM_KEY]
                ? { ...item, [field]: event.value }
                : item
        );
        let resultData = process(newData, dataState);
        setResult(resultData);
        getSelectedItems(selectedState, newData);

    };

    const expandWithItemChange = (event: any) => {
        const field = event.field || "";
        const newData = result?.data?.map((item: any) =>
            item[DATA_ITEM_KEY] === event.dataItem[DATA_ITEM_KEY]
                ? { ...item, [field]: event.value }
                : item
        );

        setResult({ ...result, data: newData });
        getSelectedItems(selectedState, newData);
    }

    const isColumnActive = (field: string, dataState: any) => {
        return (
            GridColumnMenuFilter.active(field, dataState.filter)
        );
    };



    const reorder = (dataItem: any, direction: "before" | "after") => {

        if (activeItem === dataItem) {
            return;
        }
        let reorderedData = result?.data?.slice();
        let prevIndex = reorderedData.findIndex((p: any) => p === activeItem);
        let nextIndex =
            reorderedData.findIndex((p: any) => p === dataItem) +
            (direction === "before" ? -1 : 0);
        if (prevIndex > nextIndex) {
            nextIndex++;
        }
        reorderedData.splice(prevIndex, 1);
        reorderedData.splice(nextIndex, 0, activeItem || reorderedData[0]);

        setResult(process(reorderedData, dataState));

    };

    const dragStart = (dataItem: any) => {
        setActiveItem(dataItem);
    };


    const columnMapping = (dataItems: any) => {
        return dataItems?.map((item: any) => {
            return (item.show || item.show == undefined) && <Column
                field={item.field}
                id={item.field + item.title}
                // columnMenu={item.columnMenu ? item.filterUI ? customColumnMenu : ColumnMenuconst : null}
                columnMenu={item.columnMenu ? ColumnMenuconst : null}
                headerClassName={isColumnActive(item.field, dataState) ? `active ${item.headerClassName}` : item.headerClassName}
                fixedScroll={item.fixedScroll}
                sortable={item.sortable}
                title={item.title}
                filter={item.filter}
                filterable={item.filterable}
                width={helperfunctions.getTextWidth(item.title, "12px Notosans-Semibold", item.width)}
                // width={item?.width}
                cell={item?.cell}
                headerCell={item.headerCell ? item.headerCell : headerCellComponent}
                CommandCell={item.CommandCell}
                editor={item.editor}
                format={item.format}
                editable={item.editable}
                type={item.type}
                key={item.field}
                locked={item?.locked}
                show={item.show}>
                {item?.children ? columnMapping(item?.children) : null}
            </Column>
        })
    }

    const CommandCell = (props: any) => (
        <MyCommandCell
            {...props}
            edit={edit}
            update={update}
            cancel={cancel}
            editField={EDIT_FIELD}
        />
    );

    const gridDataState = props.dataState ? props.dataState : dataState;
    return (
        <div>
            <LocalizationProvider language="en">
                <Tooltip openDelay={100} position="bottom" anchorElement="target">
                    <ReorderContext.Provider value={{ reorder: rowReOrder ? reorder : '', dragStart: rowReOrder ? dragStart : '' }}>
                        <DragAndDrop>
                            <DateInputPropsContext.Provider value={dateInputProps} >
                                <Grid
                                    data={!selection ? result : {
                                        total: result.total,
                                        data: result.data?.length > 0 ? result.data.map((item: any) => ({
                                            ...item,
                                            [SELECTED_FIELD]: selectedState[idGetter(item)],
                                        })) : []
                                    }}
                                    detail={DetailRow ? props.DetailComponent : null}
                                    {...gridDataState}
                                    total={result.total}
                                    onDataStateChange={props.onDataStateChange ? props.onDataStateChange : dataStateChange}
                                    sortable={sortable}
                                    fixedScroll={true}
                                    headerCell={true}
                                    dataItemKey={DATA_ITEM_KEY}
                                    pageable={pagination ? state.pageable : null}
                                    pageSize={pagination ? state.pageSize : null}
                                    selectedField={SELECTED_FIELD}
                                    selectable={{
                                        enabled: false,
                                        drag: false,
                                        cell: false,
                                        mode: "multiple",
                                    }}
                                    onSelectionChange={onSelectionChange}
                                    onHeaderSelectionChange={(e: any) => onHeaderSelectionChange(e, data)}
                                    expandField={"expanded"}
                                    onItemChange={inlineEdit ? itemChange : (isExpandWithItemChange ? expandWithItemChange : props.onItemChange)}
                                    cellRender={inlineEdit ? customCellRender : null}
                                    rowRender={inlineEdit ? customRowRender : rowReOrder ? (row: any, rowProps: any) => (
                                        <DraggableRow elementProps={row.props} {...rowProps} />
                                    ) : null}
                                    editField={EDIT_FIELD}
                                    editable={true}
                                    onExpandChange={onExpand}
                                    groupable={props.groupable}
                                    reorderable={props.reorderable}
                                    onFilterChange={props.onFilterChange ? props.onFilterChange : null}
                                    filterOperators={filterOperators}
                                    exitEdit={exitEdit}
                                    ref={props.gridRef ? props.gridRef : null}
                                // onScroll={(e:any)=>(dispatchDragAndDrop(e))}
                                >

                                    {
                                        selection ?
                                            <Column
                                                field={SELECTED_FIELD}
                                                headerClassName="SelectAllcls"
                                                width="80px"
                                                editable={false}
                                                type={SELECTED_FIELD}
                                                key={SELECTED_FIELD}
                                                headerSelectionValue={
                                                    result.data?.length ? result.data?.findIndex((item: any) => !selectedState[idGetter(item)]) === -1 : false
                                                }
                                            /> : null
                                    }
                                    {
                                        inlineRowEdit ? <Column editable={false} cell={CommandCell} title="Action" width="70px" /> : null
                                    }
                                    {
                                        rowReOrder ? <Column title="" width="50px" cell={DragHandleCell} /> : null
                                    }

                                    {columnMapping(props.dataColumn)}

                                </Grid>
                            </DateInputPropsContext.Provider>
                        </DragAndDrop>
                    </ReorderContext.Provider>
                </Tooltip>
            </LocalizationProvider>
        </div>);
};

DataTable.defaultProps = {
    data: [],
    dataColumn: [],
    defaultPageSize: 10,
    Selection: false,
    DetailRow: false,
    inlineEdit: false,
    sortable: true,
    pagination: true,
    selectedField: "selected",
    dataItemKey: "id",
    getSelectedValue: () => { },
    edit: () => { },
    update: () => { },
    cancel: () => { },
    onItemChange: () => { },
    editable: false,
    inlineRowEdit: false,
    reorderable: false,
    isSelect: false,
    isExpandWithItemChange: false,
    rowReOrder: false,
}
export default DataTable
